// extracted by mini-css-extract-plugin
module.exports = {"video":"styles_video__3lhJn","overlay":"styles_overlay__1Vxjd","overlayFlex":"styles_overlayFlex__1iZfO","overlayText":"styles_overlayText__1tusi","icon":"styles_icon__10_3y"};